import * as yup from 'yup'

export const partialRmaSchema = yup.object().shape({
  refundType: yup.string().required('Refund Type is required'),
  products: yup
    .array()
    .of(
      yup.object().shape({
        barcode: yup.string().required('Barcode is required'),
        returnQty: yup
          .number()
          .typeError('Return quantity is required')
          .min(0, 'Quantity must be at least 0')
          .required('Return quantity is required'),

        reason: yup
          .string()
          .optional()
          .test('reason-test', 'Return reason is required', function (value) {
            const {
              parent: { returnQty },
            } = this

            return !(returnQty > 0 && !value)
          }),
        condition: yup
          .string()
          .optional()
          .test('condition-test', 'Condition is required', function (value) {
            const {
              parent: { returnQty },
            } = this

            return !(returnQty > 0 && !value)
          }),
      }),
    )
    .required('Rma is required'),
})

export const fullRmaSchema = yup.object().shape({
  refundType: yup.string().required('Refund Type is required'),
  reason: yup.string().required('Reason is required'),
  condition: yup.string().required('Condition is required'),
})
